
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building2 } from 'lucide-react';
import { useIsDesktop } from '@/hooks/use-mobile';

const OrganizationSwitcher: React.FC = () => {
  const { currentOrganization, userMemberships, switchOrganization } = useAuth();
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  if (userMemberships.length <= 1) {
    return null; // Don't show switcher if user only has one organization
  }

  const handleOrganizationChange = async (organizationId: string) => {
    await switchOrganization(organizationId);
  };

  const component = <div className="flex items-center space-x-2">
    <Building2 className="h-4 w-4 text-muted-foreground" />
    <Select
      value={currentOrganization?.id || ''}
      onValueChange={handleOrganizationChange}
    >
      <SelectTrigger className="w-full min-w-[180px]">
        <SelectValue placeholder={t('common.selectOrganization')} />
      </SelectTrigger>
      <SelectContent>
        {userMemberships.map((membership) => (
          <SelectItem
            key={membership.organization_id}
            value={membership.organization_id}
          >
            <div className="flex items-center space-x-2">
              <span>{membership.organization_name}</span>
              <span className="text-xs text-muted-foreground">
                ({membership.user_role})
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>


  return isDesktop ? <div className="px-4 pb-4 group-data-[collapsible=icon]:hidden">{component}</div> : <div className='pt-4'>
    {component}
  </div>
};

export default OrganizationSwitcher;
